export default __webpack_public_path__ + "static/100--stacked-bar-e55083907142a7e5a12cb24b1b4e4d2d.png";